import { setLoaderComplete, setLoaderStart } from "../loader/loader"
import { getUserCategoryQuery, userCategoryMutation } from "../../lib/graphql";
import showToaster from "../../helpers/toastrMessgaes/showToaster";

export function updateUserCategory(values) {

    return async (dispatch, getState, { client }) => {

        dispatch(setLoaderStart('updateUserCategory'))

        const { categories, categoryId, profileId } = values

        const { data } = await client.mutate({
            mutation: userCategoryMutation,
            variables: {
                data: JSON.stringify(categories),
                categoryId: categoryId,
                profileId: profileId
            },
            refetchQueries: [{
                query: getUserCategoryQuery,
                variables: {
                    profileId: profileId
                }
            }]
        })

        dispatch(setLoaderComplete("updateUserCategory"))

        if (data?.userCategory?.status == 200) {
            showToaster({ messageId: 'userCategory', toasterType: 'success' });
        } else {
            showToaster({ messageId: 'errorMessage', requestContent: data?.userCategory?.errorMessage, toasterType: 'error' });
        }

    }

}